import PadraoModel from 'src/core/model/PadraoModel.js'

export default class TipoNegociacaoModel extends PadraoModel {
  recurso = 'tipos-negociacoes';
  microServico = 'negociacao';
  include = null;
  searchFixo = null;
  nome = 'Tipos de negociação';

  colunasGrid = [
    { name: 'acoes', label: 'Ações', field: 'acoes', sortable: false, style: 'width: 50px', align: 'left' },
    { name: 'id', label: 'Cód', field: 'id', sortable: true, align: 'left', buscaTipo: 'inteiro' },
    { name: 'nome', label: 'Nome', field: 'nome', descending: true, sortable: true, align: 'left', buscaTipo: 'texto' },
    { name: 'ativo', label: 'Ativo', field: 'ativo', sortable: true, descending: true, align: 'left', buscaTipo: 'boleanoSim' },
    { name: 'prioridade', label: 'Prioridade', field: 'prioridade', sortable: true, adescending: true, align: 'left', buscaTipo: 'inteiro' },
    { name: 'updated_at', label: 'Atualizado', field: 'updated_at', sortable: true, align: 'left', buscaTipo: 'dataHoraMinuto' }
  ];

  form = {
    id: null,
    nome: '',
    descricao: '',
    prioridade: 1,
    ativo: 0
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
